import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import {t, dt} from 'l10n';

import paths from 'paths';

import {formatExpirationDate} from 'utils/user';

import 'sass/headers/header.scss';

class HeaderXXL extends Component {
    render() {
        let {showExpiration, showButton, showHistoryLink = true, currentUser, children} = this.props;

        let leftBlock;
        if (showHistoryLink) {
            leftBlock = <p><Link to={paths.memberPaymentHistory.path}>{dt('xxl', 'Back to payments history')}</Link></p>;
        }


        if (showExpiration && currentUser.isXXL()) {
            let expirationDate = formatExpirationDate(currentUser, false);
            if (expirationDate) leftBlock = <p>{dt('xxl', 'Your XXL subscription is active till')} <strong>{expirationDate}</strong></p>
        }

        return (
            <header className="header-XXL">
                <div className="content">
                    <h1>{children}</h1>
                    <div className="text-header-xxl">
                        <div>{leftBlock}</div>
                        <div>
                            {showButton && <Link to={paths.buyXXL.path} className="buy-xxl">{dt('xxl', 'Buy more XXL')}</Link>}
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderXXL;


// WEBPACK FOOTER //
// ./src/components/XXL/HeaderXXL.js